import styled from 'styled-components'
import { authCard, authForm, authHeader, authScreen } from '../auth-card'

export default styled.article`
  ${ authScreen }

  .spinner-container {
    flex: 1;
  }

  form {
    ${ authCard }

    ${ authHeader }

    .backButton {
      width: 20px;
      height: 20px;
      margin: 0 0 20px 0;
      display: block;
      cursor: pointer;
      align-self: flex-start;
    }

    ${ authForm }
  }

`
